import { el } from "./dom.js";
import { api } from "../net/api.js";

/** Login / register panel. Resolves when the user is authenticated. */
export function authScreen(onDone: () => void): HTMLElement {
  let mode: "login" | "register" = "login";

  const screen = el("div", { class: "screen" });
  const panel = el("div", { class: "panel" });
  screen.append(panel);

  function render(): void {
    const errorEl = el("div", { class: "error" });
    const email = el("input", { type: "email", autocomplete: "email", placeholder: "you@grid.net" });
    const username = el("input", { type: "text", autocomplete: "username", placeholder: "3-20 chars, a-z 0-9 _" });
    const identifier = el("input", { type: "text", autocomplete: "username", placeholder: "email or username" });
    const password = el("input", { type: "password", autocomplete: mode === "login" ? "current-password" : "new-password", placeholder: "min 8 chars" });

    const submit = el("button", { class: "primary wide", text: mode === "login" ? "Jack In" : "Create Account" });

    const form = el("form", {});
    form.append(
      el("div", { class: "brand", text: "NEON PURGE" }),
      el("div", { class: "hint", style: "color:#9dff00;opacity:0.85", text: "🎮 best experienced with a controller" }),
      el("div", { class: "brand-sub", text: "GUN GAME" }),
    );
    if (mode === "register") {
      form.append(
        el("label", { text: "Email" }), email,
        el("label", { text: "Username" }), username,
        el("div", { class: "hint field-hint", text: "3–20 characters — letters, numbers, or _ only (no spaces or accents)" }),
      );
    } else {
      form.append(el("label", { text: "Email / Username" }), identifier);
    }
    form.append(el("label", { text: "Password" }), password);
    if (mode === "register") {
      form.append(el("div", { class: "hint field-hint", text: "at least 8 characters" }));
    }
    form.append(submit, errorEl);

    const switchLink = el("a", {
      text: mode === "login" ? "create one" : "log in",
    });
    switchLink.onclick = () => {
      mode = mode === "login" ? "register" : "login";
      render();
    };
    form.append(
      el(
        "div",
        { class: "hint" },
        mode === "login" ? "no account? " : "have an account? ",
        switchLink,
      ),
    );

    // anonymous play — throwaway identity, nothing saved
    const guestBtn = el("button", { class: "wide", type: "button", text: "Play as Guest" });
    guestBtn.onclick = async () => {
      errorEl.textContent = "";
      guestBtn.disabled = true;
      try {
        await api.loginAsGuest();
        onDone();
      } catch (err) {
        errorEl.textContent = friendly((err as Error).message);
        guestBtn.disabled = false;
      }
    };
    form.append(
      guestBtn,
      el("div", { class: "hint", text: "guests keep nothing — no stats, skins, or leaderboard" }),
    );

    // turn cryptic server/validation errors into friendly guidance
    const friendly = (raw: string): string => {
      const s = raw.toLowerCase();
      if (s.includes("username must match") || s.includes("pattern")) {
        return "Username must be 3–20 characters using only letters, numbers, or _ (no spaces or accents).";
      }
      if (s.includes("password") && s.includes("fewer than 8")) return "Password must be at least 8 characters.";
      if (s.includes("email") && (s.includes("format") || s.includes("match"))) return "Please enter a valid email address.";
      if (s.includes("already taken")) return "That email or username is already registered — try logging in instead.";
      if (s.includes("invalid credentials")) return "Wrong email/username or password.";
      if (s.includes("too many") || s.includes("rate")) return "Too many attempts — wait a minute and try again.";
      return raw;
    };

    form.onsubmit = async (e) => {
      e.preventDefault();
      errorEl.textContent = "";
      // client-side checks first, with clear messages
      if (mode === "register") {
        const u = username.value.trim();
        if (!/^[A-Za-z0-9_]{3,20}$/.test(u)) {
          errorEl.textContent = "Username must be 3–20 characters using only letters, numbers, or _ (no spaces or accents).";
          return;
        }
        if (password.value.length < 8) {
          errorEl.textContent = "Password must be at least 8 characters.";
          return;
        }
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value.trim())) {
          errorEl.textContent = "Please enter a valid email address.";
          return;
        }
      }
      submit.disabled = true;
      try {
        if (mode === "login") await api.login(identifier.value.trim(), password.value);
        else await api.register(email.value.trim(), username.value.trim(), password.value);
        onDone();
      } catch (err) {
        errorEl.textContent = friendly((err as Error).message);
        submit.disabled = false;
      }
    };

    panel.replaceChildren(form);
  }

  render();
  return screen;
}
